export const PDP_GALLERY_SLIDER_CONFIG = {
  dots: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  swipeToSlide: true,
  swipe: true,
  arrows: true,
  infinite: false,
  centerMode: false,
  focusOnSelect: false,
}
